import { c as _c } from "react/compiler-runtime";
import React, { FC } from 'react';
import { InfoCircle } from '@components/icons';
import { Trans, useTranslation } from 'react-i18next';
import ReactDOMServer from 'react-dom/server';
export const GraphTooltip: FC<{
  color?: string;
  label: string;
  height?: number;
  width?: number;
}> = t0 => {
  const $ = _c(18);
  const {
    label,
    height,
    width,
    color
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== color || $[1] !== label || $[2] !== t) {
    let t2;
    if ($[4] !== label || $[5] !== t) {
      t2 = t(label);
      $[4] = label;
      $[5] = t;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== color) {
      t3 = {
        color: <span style={{
          color
        }} />
      };
      $[7] = color;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
      t4 = <Trans i18nKey={t2} components={t3} />;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t1 = ReactDOMServer.renderToStaticMarkup(t4);
    $[0] = color;
    $[1] = label;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = height || 12;
  const t3 = width || 12;
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <InfoCircle height={t2} width={t3} stroke="#fff" fill="#727D9F" />;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t4) {
    t5 = <div data-tooltip-id="mobile-enabled-tooltip" data-tooltip-html={t1} className="w-fit">{t4}</div>;
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export const createSvgLine = ({
  key,
  stroke,
  strokeWidth = '4',
  strokeDasharray,
  x2 = 16
}) => <line key={key} stroke={stroke} strokeWidth={strokeWidth} strokeDasharray={strokeDasharray} x1={0} x2={x2} y1={8} y2={8} />;
export const createSvgErrorBar = ({
  key,
  color,
  low,
  high
}) => <g key={key}>
    <line x1={8} x2={8} y1={low} y2={high} stroke={color} strokeWidth={1} />
    <line x1={4} x2={12} y1={low} y2={low} stroke={color} strokeWidth={1} />
    <line x1={4} x2={12} y1={high} y2={high} stroke={color} strokeWidth={1} />
  </g>;